
























































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { v4 } from 'uuid'

@Component
export default class SylvanaWaiting1 extends Vue {

    uuid: string = v4()

    @Prop({default: '#49a18a'}) color!: string

    createReference(id: string): string {
        return '#' + this.createId(id)
    }

    createId(id: string): string {
        return 'avatar-id-' + this.uuid + id
    }

    createUrlReference(id: string): string {
        return 'url(#' + this.createId(id) + ')'
    }
}
